import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {LorenAuthenticationService} from '../../services/loren-authentication-service/loren-authentication.service';
import {LOREN_ROUTES} from '../../constants/loren-routes.constants';

@Injectable({
    providedIn: 'root'
})
export class LorenAuthenticationGuard  {
    private authenticationService = inject(LorenAuthenticationService);
    private router = inject(Router);


       canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const isAuthenticated = this.authenticationService.isAuthenticated();

        if (isAuthenticated) {
            return true;
        }

        this.router.navigate([LOREN_ROUTES.LOGIN], {queryParams: {returnUrl: state.url}});
        return false;
    }
}
